import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import moment from 'moment';
import { Collapse } from 'antd';

import Input from '../../formComponents/Input';
import Checkbox from '../../formComponents/Checkbox';
import Radio from '../../formComponents/Radio';
import Datepicker from '../../formComponents/Datepicker';


class OPDDefault extends Component {
    render() {
        return (
            <Fragment>
                <div className="container">
                    <div>
                        <p>Настоящим, во исполнение требований Закона РК «О персональных данных и их защите» № 94-V ЗРК от 21.05.2013 г., я, </p>
                        <div className="form">
                            <div className="item">
                                <Field name='lastName' component={Input} placeholder={this.props.t('fields.lastName')} />
                            </div>
                            <div className="item">
                                <Field name='firstName' component={Input} placeholder={this.props.t('fields.firstName')} />
                            </div>
                            <div className="item">
                                <Field name='middleName' component={Input} placeholder={this.props.t('fields.middleName')} />
                            </div>
                            <div className="item">
                                <Field name='birthdate' component={Datepicker} placeholder={this.props.t('fields.birthdate')} max={moment()} />
                            </div>
                            <div className="item">
                                <Field name='phone' component={Input} placeholder={this.props.t('fields.phone')} />
                            </div>
                            <div className="item">
                                <Field name='emailPersonal' disabled={true} component={Input} placeholder={this.props.t('fields.email')} />
                            </div>
                            <div className="item">
                                <Field name='address' component={Input} placeholder={this.props.t('fields.address')} />
                            </div>
                        </div>
                    </div>
                    <div>
                        <p>действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, </p>
                    </div>
                    <div className="item-form">
                        <Field
                            required={true}
                            name='SoglasieOPD'
                            component={Checkbox}
                            text={<span>Даю свое согласие ТОО «АНКОР ПЕРСОНАЛ Центральная Азия» (юридический адрес: г. Алматы, Алмалинский район, ул. Желтоксан, 115), его обособленным подразделениям и его Группе лиц<sup>1</sup> (далее – «Оператор») на обработку своих персональных данных в следующих целях:</span>} />
                    </div>
                    <div>
                        <ul>
                            <li>содействие в трудоустройстве или организация иного вида сотрудничества;</li>
                            <li>проведение предварительного собеседования в целях трудоустройства или иного вида занятости;</li>
                            <li>осуществления Оператором деятельности, связанной с аналитикой рынка труда и управлением человеческими ресурсами, в том числе посредством помещения персональных данных Соискателя в резерв соискателей.</li>
                        </ul>
                        <p>Также даю согласие на:</p>
                        <ul>
                            <li>передачу, в том числе трансграничную, моих персональных данных Оператору,  юридическим лицам, входящим в Группу лиц Оператора, и  третьим лицам – клиентам Оператора<sup>2</sup> – в указанных выше целях; </li>
                            <li>поручение обработки моих персональных данных ООО «ТимСервис» (111024, Российская Федерация, г. Москва, ш. Энтузиастов, д. 21, стр. 2) и ООО «Экспириум» (109544, Российская Федерация г Москва, б-р Энтузиастов, 2, этаж 13, ком. 36) с целью технической поддержки информационных систем Оператора.</li>
                        </ul>
                        <p>Категории персональных данных:</p>
                        <ul>
                            <li>фамилия, имя, отчество;</li>
                            <li>пол;</li>
                            <li>фотография;</li>
                            <li>контактный телефон;</li>
                            <li>адрес электронной почты;</li>
                            <li>дата рождения;</li>
                            <li>гражданство;</li>
                            <li>город и район проживания;</li>
                            <li>адрес личной интернет-страницы в социальных сетях;</li>
                            <li>готовность к переезду и командировкам;</li>
                            <li>семейное положение;</li>
                            <li>сведения об образовании и полученной специальности;</li>
                            <li>сведения о предыдущих местах работы;</li>
                            <li>уровень владения компьютером;</li>
                            <li>уровень владения иностранными языками;</li>
                            <li>сведения о наличии специальных профессиональных навыков;</li>
                            <li>зарплатные ожидания;</li>
                            <li>другие персональные данные, которые я сочту необходимым включить в свое резюме;</li>
                            <li>рекомендации с предыдущих мест работы.</li>
                        </ul>
                    </div>
                    <div className="item-form">
                        <Field
                            required={true}
                            name='SoglasieMSG'
                            component={Radio}
                            text='Также даю согласие на получение информационных рассылок о появляющихся карьерных возможностях, об обучающих материалах и приглашениях на мероприятия в этой сфере:' />
                    </div>
                    <div>
                        <p>
                            Настоящее согласие действует до момента получения отзыва согласия на обработку персональных данных. С порядком отзыва<sup>3</sup> согласия на обработку персональных данных ознакомлен.
                        </p>
                    </div>
                    <small className='text-ref'>
                        <sup>1</sup>&nbsp;Понятие «Группа лиц» используется в значении понятия «группы лиц», определенного статьей 7 Закона Республики Казахстан №112-IV от 25.12.2008 «О конкуренции». <br/>
                        <sup>2</sup>&nbsp;Данные Соискателя могут быть переданы только Клиентам Оператора и Группы лиц Оператора – являющимся потенциальными работодателями для Соискателя. <br />
                        <sup>3</sup>&nbsp;Отзыв согласия на обработку персональных данных должен содержать полные ФИО, дату рождения, электронную почту, мобильный телефон, личную подпись Соискателя.
                        <br />
                        О порядке отзыва согласия из Закона РК «О персональных данных и их защите» (№ 94-V ЗРК): «субъект или его законный представитель дает (отзывает) согласие на сбор, обработку персональных данных письменно или в форме электронного документа либо иным способом с применением элементов защитных действий, не противоречащих законодательству Республики Казахстан. Субъект или его законный представитель не может отозвать согласие на сбор, обработку персональных данных в случаях, если это противоречит законам Республики Казахстан, либо при наличии неисполненного обязательства».
                        <br />
                        Скан-копию отзыва можно направить на адрес <a href="mailto:privacy@ancor.kz">privacy@ancor.kz</a>. Бумажный оригинал отзыва может быть представлен в любой офис Группы компаний ANCOR. Оператор обязан прекратить обработку и уничтожить персональные данные после поступления указанного отзыва, за исключением тех персональных данных, обработка которых может осуществляться без согласия субъекта персональных данных на основаниях, предусмотренных Законом Республики Казахстан «О персональных данных и их защите» № 94-V ЗРК от 21 мая 2013 года или другими нормативными правовыми актами.
                    </small>
                </div>
            </Fragment>
        );
    }
}

export default OPDDefault;
